import { Area } from "tht-impianti-cl";

export enum AreaSelectionActionTypes {
  SET_AREAS = "[Area Selection] Set Areas",
  SET_SELECTED_AREA = "[Area Selection] Set Selected Area",
  SET_LOADING = "[Area Selection] Set Loading"
}

export interface SetAreasAction {
  type: AreaSelectionActionTypes.SET_AREAS;
  payload: Area[];
}

export interface SetSelectedAreaAction {
  type: AreaSelectionActionTypes.SET_SELECTED_AREA;
  payload: string | null; // null for "all"
}

export interface SetLoadingAction {
  type: AreaSelectionActionTypes.SET_LOADING;
  payload: boolean;
}

export type AreaSelectionActions = 
  | SetAreasAction
  | SetSelectedAreaAction
  | SetLoadingAction;

export const setAreas = (areas: Area[]): SetAreasAction => ({
  type: AreaSelectionActionTypes.SET_AREAS,
  payload: areas
});

export const setSelectedArea = (areaId: string | null): SetSelectedAreaAction => ({
  type: AreaSelectionActionTypes.SET_SELECTED_AREA,
  payload: areaId
});

export const setLoading = (loading: boolean): SetLoadingAction => ({
  type: AreaSelectionActionTypes.SET_LOADING,
  payload: loading
}); 